import { Paper } from "@material-ui/core";
import React from "react";
import { useState } from "react";
import { useEffect } from "react";
import { baseUrl } from "../../../../services/config";
import MySelect from "../../CustomChallan/MySelect";
import makeAnimated from "react-select/animated";
import { components } from "react-select";
import { useAlert } from "react-alert";
import { useSelector } from "react-redux";

const ResultSequence = () => {
  const alert = useAlert();
  const authtoken = localStorage.getItem("userToken");
  const [allsessions, setallsessions] = useState([]);
  const [currentsession, setcurrentsession] = useState("");
  const user = useSelector((state) => state.user.user);
  const [campuses, setallcampuses] = useState(user.campuses || []);
  const [allexamslist, setallexamslist] = useState([]);
  const [selectedExamType, setselectedExamType] = useState("");
  const [allsubjects, setallsubjects] = useState([]);
  const [optionSelected, setoptionSelected] = useState([]);
  const [selectedsubjects, setselectedsubjects] = useState([]);
  const [loading, setLoading] = useState(false);

  const [campusCourseData, setCampusCourseData] = useState([]);
  const [courseClassData, setCourseClassData] = useState([]);

  const [campusId, setCampusId] = useState("");
  const [courseId, setCourseId] = useState("");
  const [classId, setClassId] = useState("");

  useEffect(() => {
    getAllSessions();
    getAllSubjects();
  }, []);

  ///getting years
  const getAllSessions = () => {
    fetch(`${baseUrl}/session`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${authtoken}`,
      },
    })
      .then((res) => res.json())
      .then((data) => {
        console.log(data);
        setallsessions([...data.payload]);
        data.payload.forEach((session, index) => {
          if (session.active_academic_year == "1") {
            setcurrentsession(session.id);
            // getAllExamsList(session.id)
          }
        });
      })
      .catch((err) => {
        console.log(err);
      });
  };

  //on year change
  const onChangeSession = (id) => {
    setcurrentsession(id);
  };

  const onCampusChange = async (id) => {
    setCampusId(id);
    getCampusCourses(id);
  };

  const getCampusCourses = async (campusId) => {
    setCampusCourseData([]);
    setCourseClassData([]);

    if (campusId == "") {
      return alert.error("Please Select Campus");
    }
    await fetch(`${baseUrl}/campus-all-courses/${campusId}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${authtoken}`,
      },
    })
      .then((res) => {
        res.json().then((data) => {
          setCourseId("");
          setClassId("");
          setCampusCourseData(data.payload);
        });
      })
      .catch((err) => {
        alert.error(err);
      });
  };

  const onCourseChange = (id) => {
    setCourseId(id);
    getAllExamsList(id);
    getCourseClasses(id);
  };

  const getCourseClasses = async (courseId) => {
    setCourseClassData([]);

    if (courseId == "") {
      return alert.error("Please Select Course");
    }

    await fetch(`${baseUrl}/course-all-classes/${courseId}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${authtoken}`,
      },
    })
      .then((res) => {
        res.json().then((data) => {
          setClassId("");
          setCourseClassData(data.payload);
        });
      })
      .catch((err) => {
        alert.error(err);
      });
  };

  ///getting exams
  const getAllExamsList = (id) => {
    const data = {
      year_id: currentsession,
      campus_id: campusId,
      course_id: id,
    };

    fetch(`${baseUrl}/exam_for_session`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${authtoken}`,
      },
      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then((data) => {
        setallexamslist([...data.payload]);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  //get all subjects
  const getAllSubjects = () => {
    fetch(`${baseUrl}/subject`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${authtoken}`,
      },
    })
      .then((res) => res.json())
      .then((data) => {
        console.log(data);
        setallsubjects(data.payload);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  ///handle submit
  const handleSubmit = () => {
    setLoading(true);
    const fdata = new FormData();
    fdata.append("exam_id", selectedExamType);
    fdata.append("campus_id", campusId);
    fdata.append("course_id", courseId);
    fdata.append("student_class_id", classId);
    for (let i = 0; i < selectedsubjects.length; i++) {
      fdata.append("subject_ids[]", selectedsubjects[i]);
    }

    fetch(`${baseUrl}/result_sequence`, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${authtoken}`,
      },
      body: fdata,
    })
      .then((resp) => {
        setLoading(false);
        resp.json().then((data) => {
          if (data.metadata) {
            if (data.metadata.success) {
              alert.success(data.metadata.message);
            } else if (!data.metadata.success) {
              Object.values(data.metadata.message).map((msg) => {
                alert.error(msg);
              });
            }
          }
        });
      })
      .catch((err) => {
        setLoading(false);
        console.log(err);
        alert.error("Opps something wents wronge");
      });
  };

  //multiselect
  const animatedComponents = makeAnimated();
  const Option = (props) => {
    return (
      <div>
        <components.Option {...props}>
          <input
            type="checkbox"
            checked={props.isSelected}
            onChange={() => null}
          />{" "}
          <label>{props.label}</label>
        </components.Option>
      </div>
    );
  };
  const MultiValue = (props) => (
    <components.MultiValue {...props}>
      <span>{props.data.label}</span>
    </components.MultiValue>
  );
  const Options = [];
  allsubjects.map((item, index) => {
    Options[index] = { value: item.id, label: item.name };
  });

  const handleChangeSubjects = (selected) => {
    console.log(selected);
    if (optionSelected.length == 30 && selected.length == 30) {
      setoptionSelected([]);
      return;
    }
    setoptionSelected([...selected]);
    let valuearray = [];

    selected.map((item, index) => {
      valuearray[index] = item.value;
    });
    setselectedsubjects([...valuearray]);
  };

  return (
    <>
      <Paper
        style={{ marginTop: "10px", marginBottom: "10px", padding: "10px" }}
      >
        <div className="row">
          <div className="col-md-3">
            <label>
              <b>Select Session</b> <span style={{ color: "red" }}>*</span>
            </label>
            <select
              onChange={(e) => onChangeSession(e.target.value)}
              class="form-select"
              style={{ height: 40 }}
              value={currentsession}
              aria-label="Default select example"
            >
              <option value="">Select Session</option>
              {allsessions.map((session) => (
                <option value={session.id}>{session.year}</option>
              ))}
            </select>
          </div>

          <div className="col-md-3">
            <label>
              <b>Select Campus</b> <span style={{ color: "red" }}>*</span>
            </label>
            <select
              style={{ height: 40 }}
              className="form-select"
              name="campus_id"
              value={campusId}
              onChange={(e) => onCampusChange(e.target.value)}
              aria-label="Default select example"
            >
              <option value=""> Select Campus</option>
              {campuses.map((campus, index) => (
                <option key={index} value={campus.id}>
                  {campus.name}
                </option>
              ))}
            </select>
          </div>

          <div className="col-md-3">
            <label>
              <b>Select Course </b> <span style={{ color: "red" }}>*</span>
            </label>
            <select
              className="form-select"
              name="course_id"
              value={courseId}
              onChange={(e) => onCourseChange(e.target.value)}
              style={{ backgroundColor: "white", height: 40 }}
              aria-label="Default select example"
            >
              <option value="">Select Course</option>
              {campusCourseData.map((item, index) => (
                <option key={index} value={item.course?.id}>
                  {item.course?.name}
                </option>
              ))}
            </select>
          </div>

          <div className="col-md-3">
            <label>
              <b>Select Exam</b> <span style={{ color: "red" }}>*</span>
            </label>
            <select
              onChange={(e) => {
                setselectedExamType(e.target.value);
              }}
              class="form-select"
              style={{ height: 40 }}
              value={selectedExamType}
              aria-label="Default select example"
            >
              <option value="">Select Exam</option>
              {allexamslist.map((exam) => (
                <option value={exam.id}>{exam?.exam_name}</option>
              ))}
            </select>
          </div>
        </div>
        <div className="row mt-5">
          <div className="col-md-3">
            <label>
              <b>Select Class</b> <span style={{ color: "red" }}>*</span>
            </label>

            <select
              style={{ height: 40 }}
              className="form-select"
              name="class_id"
              value={classId}
              onChange={(e) => setClassId(e.target.value)}
              aria-label="Default select example"
            >
              <option value=""> Select Class</option>
              {courseClassData.map((item, index) => (
                <option key={index} value={item.class?.id}>
                  {item.class?.name}
                </option>
              ))}
            </select>
          </div>

          <div className="col-md-6">
            <label>
              <b>
                Select subjects <span style={{ color: "red" }}>*</span>
              </b>
            </label>
            <MySelect
              options={Options}
              isMulti
              name="selectedOptions"
              closeMenuOnSelect={true}
              hideSelectedOptions={false}
              components={{ Option, MultiValue, animatedComponents }}
              onChange={handleChangeSubjects}
              allowSelectAll={true}
              value={optionSelected}
            />
          </div>
          <div className="col-md-2 mt-9">
            <button
              disabled={loading}
              className="btn btn-primary"
              onClick={handleSubmit}
            >
              Submit
            </button>
          </div>
        </div>
      </Paper>
    </>
  );
};

export default ResultSequence;
